import type { RouteRecordRaw } from "vue-router";
import { isSpecialAdmin } from "@/functions/environment.ts";

const routes: RouteRecordRaw[] = [
  {
    path: "/iot",
    redirect: { name: "IoTDeviceList" },
    children: [
      {
        path: "states",
        name: "IoTStateList",
        component: () => import("./views/IoTStateList.vue"),
        meta: { rights: ["iot.admin"] },
      },
      {
        path: "states/:id",
        name: "IoTStateHistory",
        component: () => import("./views/IoTStateHistory.vue"),
        meta: { rights: ["iot.admin"] },
        props: (route) => ({ id: String(route.params.id) }),
      },
      {
        path: "devices",
        name: "IoTDeviceList",
        component: () => import("./views/IoTDeviceList.vue"),
        meta: { rights: ["iot.admin"] },
      },
      {
        path: "devices/create",
        name: "IoTDeviceCreate",
        component: () => import("./views/IoTDeviceForm.vue"),
        meta: { rights: ["iot.admin"] },
      },
      {
        path: "devices/:id",
        name: "IoTDeviceUpdate",
        component: () => import("./views/IoTDeviceForm.vue"),
        meta: { rights: ["iot.admin"] },
        props: (route) => ({ id: String(route.params.id) }),
      },
      {
        path: "devices/:id/rules",
        name: "IoTRuleEditor",
        component: () => import("./views/IoTRuleEditor.vue"),
        meta: { rights: ["iot.admin"] },
        props: (route) => ({ id: String(route.params.id) }),
      },
      {
        path: "provisioned-devices",
        name: "IoTProvisionedDeviceList",
        component: () => import("./views/IoTProvisionedDeviceList.vue"),
        meta: { rights: ["iot.admin"] },
        beforeEnter: () => (isSpecialAdmin() ? true : { name: "IoTDeviceList" }),
      },
      {
        path: "provisioned-devices/create",
        name: "IoTProvisionedDeviceCreate",
        component: () => import("./views/IoTProvisionedDeviceForm.vue"),
        meta: { rights: ["iot.admin"] },
        beforeEnter: () => (isSpecialAdmin() ? true : { name: "IoTDeviceList" }),
      },
      {
        path: "provisioned-devices/:deviceId",
        name: "IoTProvisionedDeviceUpdate",
        component: () => import("./views/IoTProvisionedDeviceForm.vue"),
        meta: { rights: ["iot.admin"] },
        beforeEnter: () => (isSpecialAdmin() ? true : { name: "IoTDeviceList" }),
        props: (route) => ({ deviceId: String(route.params.deviceId) }),
      },
    ],
  },
];

export default routes;
